export const isTest = process.env.REACT_APP_ENV === 'test';
export const isDebug = process.env.REACT_APP_ENV === 'development';
export const isStaging = process.env.REACT_APP_ENV === 'staging';
export const isProduction = process.env.REACT_APP_ENV === 'production';
export const isClient = typeof window !== 'undefined';
export const recaptchaSiteKey = isDebug ?
  '6LfcPcgUAAAAAKwBfZJ6UUVxPde78lsBxZ87QrUz' :
  '6LeYE8gUAAAAAAOOpKuOKWkzIZL3l5_lG9yg2VF5';
